import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'semantic-ui-react'
import AliquotaTributo from './AliquotaTributo'

const RenderAliquotasTributos = ({ fields, loading }) => {
  return (
    <Table.Body>
      { fields.map((aliquotaTributo, index) => (
        <AliquotaTributo
          key={index}
          aliquotaTributo={aliquotaTributo}
          loading={loading}
        />
      ))}
    </Table.Body>
  )
}

RenderAliquotasTributos.propTypes = {
  fields: PropTypes.object,
  loading: PropTypes.bool,
}

export default RenderAliquotasTributos
